import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dotdotdot, Video } from 'components';
import * as styles from './PostListItem.scss';
import PostListContent from './PostListContent';

var PostListItem = /*#__PURE__*/function (_Component) {
  _inherits(PostListItem, _Component);

  var _super = _createSuper(PostListItem);

  function PostListItem() {
    _classCallCheck(this, PostListItem);

    return _super.apply(this, arguments);
  }

  _createClass(PostListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          aboveLeftContentStyle = _this$props.aboveLeftContentStyle,
          aboveLeftContent = _this$props.aboveLeftContent,
          belowMessageContent = _this$props.belowMessageContent,
          image = _this$props.image,
          postingToIcons = _this$props.postingToIcons,
          videoUrl = _this$props.videoUrl,
          message = _this$props.message,
          publishAt = _this$props.publishAt,
          wrapStyle = _this$props.wrapStyle,
          numImgs = _this$props.numImgs;
      return /*#__PURE__*/React.createElement("div", {
        style: wrapStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.itemDate
      }, aboveLeftContent && /*#__PURE__*/React.createElement("div", {
        style: aboveLeftContentStyle
      }, aboveLeftContent), moment(publishAt).format('dddd M/D/YYYY'), " at ", moment(publishAt).format('h:mm A'), postingToIcons), /*#__PURE__*/React.createElement(PostListContent, {
        image: image,
        numImgs: numImgs,
        videoUrl: videoUrl,
        belowMessageContent: belowMessageContent,
        message: message
      }));
    }
  }]);

  return PostListItem;
}(Component);

export { PostListItem as default };
PostListItem.defaultProps = {
  videoUrl: null,
  image: null,
  message: '',
  publishAt: moment(),
  wrapStyle: {},
  postingToIcons: null,
  belowMessageContent: null,
  aboveLeftContent: null,
  aboveLeftContentStyle: {}
};